import React from 'react';
import { Popover, Card, Menu, Icon, Shelf, Text } from '@chaser/components';
import { setShortCode } from '../../../duck/actions/organisation';
import AddOrganisationModal from '../AddOrganisationModal/index.jsx';
import useModal from '../../../hooks/useModal';
import useUserOrganisations from '../../../hooks/useUserOrganisations';
import useShortCode from '../../../hooks/useShortCode';
import useOrganisation from '../../../hooks/useOrganisation';
import { getOrgLabel } from '..';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../../app/login/duck/actions/login';
import useUser from '@/hooks/useUser';
import useCurrentUserRoles from '../../../hooks/useCurrentUserRoles';

import style from '../HeaderBar.module.scss';

function SwapOrganisationsMenu({ noChase, noChaseUntil }) {
  const organisation = useOrganisation(null, {
    suspense: false,
  });
  const user = useUser();
  const dispatch = useDispatch();
  const shortCode = useShortCode();
  const showModal = useModal();
  const organisations = useUserOrganisations() || [];
  const { canCreateOrganisation } = useCurrentUserRoles();
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const selected = organisations?.find(org => org.ShortCode === shortCode);
  const { name, Name } = selected || {};
  const orgName = name || Name || organisation.name || organisation.Name || '';

  return (
    <Popover
      shown={popoverOpen}
      onToggle={setPopoverOpen}
      target={
        <Shelf
          gap="xsmall"
          data-testid="org-dropdown"
          data-trackingid="org-dropdown"
          flexWrap="nowrap"
          className={style.orgDropdownTarget}
        >
          <Text color="White" trim={false} className={style.orgName}>
            {orgName} {getOrgLabel(noChase, noChaseUntil)}{' '}
          </Text>
          <Icon name="arrow-down" size="8" />
        </Shelf>
      }
    >
      <Card scrollable data-testid="org-dropdown-menu" data-trackingid="org-dropdown-menu">
        <Menu>
          {canCreateOrganisation && (
            <React.Fragment>
              <Menu.Item
                data-testid="org-dropdown-addnew-btn"
                data-trackingid="org-dropdown-addnew-btn"
                onClick={() => {
                  showModal(<AddOrganisationModal />);
                }}
              >
                + Add new organisation
              </Menu.Item>
              <Menu.Divider />
            </React.Fragment>
          )}
          {organisations.map((org, i) => (
            <Menu.Item
              data-testid={`org-dropdown-menu_item_${org.name || org.Name || org.ShortCode}`}
              data-trackingid={`org-dropdown-menu_item_${org.name || org.Name || org.ShortCode}`}
              key={i}
              onClick={() => {
                dispatch(setShortCode(org.ShortCode));
                dispatch(
                  setUserData({
                    ...user,
                    latestAccess: {
                      organisation: org.ShortCode,
                    },
                  }),
                );
                setPopoverOpen(false);
              }}
            >
              {org.name || org.Name}
            </Menu.Item>
          ))}
        </Menu>
      </Card>
    </Popover>
  );
}

export default SwapOrganisationsMenu;
